<template>
  <sf-banner-page
    v-if="showBanner"
    :title="bannerTitle"
    variant="info"
    has-long-text
    is-full-width
    @close="dismissBanner"
  >
    <div>{{ bannerDescription }}</div>
    <template #actions>
      <a
        v-if="props.supportArticleUrl.length > 0"
        class="sf-c-text sf-nowrap tw-pt-2"
        :href="props.supportArticleUrl"
        target="_blank"
        >{{ linkText }}
        <i
          class="
            tw-ml-1
            fa fa-external-link-square
            tw-text-sf-gray-light tw-pt-0.5
          "
        />
      </a>
      <a class="sf-btn tw-ml-2" @click="dismissBanner">{{
        dismissButtonText
      }}</a>
    </template>
  </sf-banner-page>
</template>

<script setup lang="ts">
import SfBannerPage from '@app/shared/vue/components/sf-banner/sf-banner-page.vue'
import { ref } from 'vue'

const I18n = window.I18n

defineOptions({
  name: 'AutomaticallyFollowedBanner',
})

interface Props {
  supportArticleUrl: string
}

const props = defineProps<Props>()
const showBanner = ref(true)

const bannerTitle = I18n.t(
  'company.following.automatically_followed_banner.title'
)
const bannerDescription = I18n.t(
  'company.following.automatically_followed_banner.description'
)
const linkText = I18n.t(
  'company.following.automatically_followed_banner.link_text'
)
const dismissButtonText = I18n.t(
  'company.following.automatically_followed_banner.dismiss_button_text'
)
function dismissBanner(): void {
  showBanner.value = false
}
</script>
